import React, { useCallback, useState } from 'react';
import { Button } from '@cp/ds/src/components/button';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { useApiServerErrorHandler } from 'src/shared/apiServer';
import { WithPaymentCallback, isPaymentRequiredError } from 'src/shared/payment';
import { UseCaseRequest } from '../model';
import { RespondToVacancyDeps, useCreateUseCase } from '../model/useCreateUseCase';

export interface ResponseButtonProps extends ButtonProps, WithPaymentCallback {
  request: UseCaseRequest;
  deps: RespondToVacancyDeps;
}

export const ResponseButton = ({ deps, request, onPaymentRequired, children = 'Откликнуться', ...props }: ResponseButtonProps) => {
  const [disabled, setDisabled] = useState(false);
  const createUseCase = useCreateUseCase();
  const handleError = useApiServerErrorHandler();
  const onClick = useCallback(async () => {
    setDisabled(true);
    const useCase = createUseCase(deps);
    const result = await useCase.execute(request);
    if (typeof result !== 'boolean') {
      if ('status' in result && isPaymentRequiredError(result) && onPaymentRequired) {
        onPaymentRequired(result);
        setDisabled(false);
      } else {
        handleError(result);
      }
    } else {
      setDisabled(false);
    }
  }, [onPaymentRequired, deps, request, createUseCase, handleError]);

  return (
    <Button color="pink" disabled={disabled} onClick={onClick} {...props}>
      {children}
    </Button>
  );
};
